// extracted by mini-css-extract-plugin
export default {"loader":"SmallLoader_loader__jtEp6","rotation":"SmallLoader_rotation__nyESm"};